import { render } from "./orderHistory.vue?vue&type=template&id=6986b42c&scoped=true&ts=true"
import script from "./orderHistory.vue?vue&type=script&lang=ts"
export * from "./orderHistory.vue?vue&type=script&lang=ts"

import "./orderHistory.vue?vue&type=style&index=0&id=6986b42c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6986b42c"]])

export default __exports__